<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Page Header-->
							<div class="page_header">Approve Solution</div>
							<!--Page Header-->
							<div class="page_main">
								<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top"
									class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													<span v-if="info.priority == 1">High</span>
													<span v-if="info.priority == 2">Medium</span>
													<span v-if="info.priority == 3">Low</span>
													<span v-if="!info.priority">/</span>
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator || "/" }}
												</div>
											</el-form-item>
										</div>
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Completion Date">
												<div class="gray-input">
													{{ info.time4 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Start Date">
												<div class="gray-input">
													{{ info.time5 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Completion Date">
												<div class="gray-input">
													{{ info.time6 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Close Date">
												<div class="gray-input">
													{{ info.pass_time || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Description of Issue, Concern, Idea, or Opportunity"
										class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<div class="text-tip">Background Information</div>
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Requester">
												<div class="gray-input">
													{{ info.username || "/" }}
												</div>
											</el-form-item>
											<!-- <el-form-item label="Company">
												<div class="gray-input">
													{{ info.company_name || "/" }}
												</div>
											</el-form-item> -->
										</div>
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Source Type">
												<div class="gray-input">
													{{ info.source_type || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Department">
												<div class="gray-input">
													{{ info.departments_name || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<el-form-item label="Source Information" class="full-width-item">
										<div class="gray-input">
											{{ info.source_info || "/" }}
										</div>
									</el-form-item>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">CAPA Background Files</div>
										</div>
										<el-table :data="backdocTableData" border stripe
											header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="name" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">
												Articles Affected by the Issue, Concern, Idea, or
												Opportunity
											</div>
										</div>
										<el-table :data="affectArticleTableData" border stripe
											header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Data">
											<el-table-column prop="" label="Article Type" min-width="180" sortable>
												<template #default="scope">
													<div v-if="scope.row.article_type == 1">Document</div>
													<div v-if="scope.row.article_type == 2">
														Equipment
													</div>
													<div v-if="scope.row.article_type == 3">Product</div>
													<div v-if="scope.row.article_type == 4">Tool</div>
													<div v-if="scope.row.article_type == 5">Other</div>
												</template>
											</el-table-column>
											<el-table-column prop="article_id" label="Article ID" min-width="110"
												sortable />
											<el-table-column prop="article_name" label="Article Name" min-width="110"
												sortable />
											<el-table-column prop="article_revision" label="Article Revision"
												min-width="140" sortable></el-table-column>
											<el-table-column prop="" label="Product Serial Number" min-width="180"
												sortable>
												<template #default="scope">
													{{ scope.row.serial_number || "N/A" }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Lot Number" min-width="160"
												sortable>
												<template #default="scope">
													{{ scope.row.lot_number || "N/A" }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Purchased Product?" min-width="200"
												sortable>
												<template #default="scope">
													<div v-if="scope.row.is_buy == 1">Yes</div>
													<div v-if="scope.row.is_buy == 2">No</div>
													<div v-else></div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Supplier" min-width="200" sortable>
												<template #default="scope">
													{{ scope.row.supplier_name || "" }}
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Correction</div>
										</div>
										<el-table :data="correctionTableData" border stripe
											header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<!-- Investigation Activity Log -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Investigation Activity Log</div>
										</div>
										<el-table :data="investigationLogTableData" border stripe
											header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Activity Log Entries">
											<el-table-column prop="description" label="Description" min-width="260"
												sortable />
											<el-table-column prop="" label="Created Time" min-width="120" sortable>
												<template #default="scope">
													{{ initTime(scope.row.update_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Last Updated" min-width="140" sortable>
												<template #default="scope">
													{{ initTime(scope.row.dateline) }}
												</template>
											</el-table-column>
											<el-table-column prop="attachment" label="Attachment" min-width="160">
												<template #default="scope">
													<div v-for="(value, index) in scope.row.filelist" :key="index"
														style="padding: 4px 0">
														<a :href="value.url" target="_blank">{{
                              value.name
                            }}</a>
													</div>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<!-- Solution Plan -->
									<div class="solution-plan">
										<!-- Title Bar -->
										<div class="plan-header">
											<span class="plan-title">Solution Plan</span>
											<el-button type="text" class="toggle-btn" @click="toggleAll">
												{{ allExpanded ? "Collapse" : "Expand All" }}
												<i :class="
                            allExpanded
                              ? 'el-icon-arrow-up'
                              : 'el-icon-arrow-down'
                          "></i>
											</el-button>
										</div>
										<!-- Content Card -->
										<div class="plan-card" v-for="(item, index) in rootCause" :key="index">
											<!-- Root Cause -->
											<section class="plan-section">
												<div class="plan-header">
													<span class="plan-title">Root Cause</span>
												</div>
												<div class="form-block">
													<el-form-item label="Root Cause Analysis Result">
														<div class="gray-input">
															{{ item.analysis_results }}
														</div>
													</el-form-item>
												</div>
												<template v-if="rootCauseExpanded == item.id || allExpanded">
													<div class="form-grid">
														<!-- Left -->
														<div class="form-col">
															<el-form-item label="Is this Root Cause Supplier Related?">
																<div class="gray-input">
																	{{ item.is_supplier == 1 ? "Yes" : "No" }}
																</div>
															</el-form-item>
														</div>
														<!-- Right -->
														<div class="form-col">
															<el-form-item label="Root Cause Supplier">
																<div class="gray-input">
																	{{ item.supplier_name }}
																</div>
															</el-form-item>
														</div>
													</div>
													<div class="custom-panel">
														<div class="panel-header">
															<div class="table-title">
																Root Cause Analysis Files
															</div>
														</div>
														<el-table :data="item.filelist" border stripe
															header-cell-class-name="table-header-cell"
															class="file-table"
															empty-text="No Root Cause Analysis Files">
															<el-table-column prop="" label="Description"
																sortablemin-width="200">
																<template slot-scope="scope">
																	<div>{{ scope.row.description || "/" }}</div>
																</template>
															</el-table-column>
															<el-table-column prop="fileName" label="File Name"
																min-width="240">
																<template slot-scope="scope">
																	<a :href="scope.row.url" target="_blank">{{
                                    scope.row.name
                                  }}</a>
																</template>
															</el-table-column>
														</el-table>
													</div>
												</template>
												<div v-if="!allExpanded" class="section-toggle">
													<el-button type="text" @click="rootCauseExpandedClick(item)">
														{{
                              rootCauseExpanded == item.id || allExpanded
                                ? "Collapse"
                                : "Expand"
                            }}
														<i :class="
                                rootCauseExpanded == item.id || allExpanded
                                  ? 'el-icon-arrow-up'
                                  : 'el-icon-arrow-down'
                              "></i>
													</el-button>
												</div>
											</section>
											<!-- Divider -->
											<div class="divider"></div>
											<!-- Corrective Action -->
											<div class="plan-card"
												v-for="(item2, index2) in item.caparootcauseaction_list" :key="index2"
												style="padding-left: 30px">
												<section class="plan-section">
													<div class="plan-header">
														<span class="plan-title">{{
                              item2.capa_type == 1
                                ? "Corrective Action"
                                : "Preventive Action"
                            }}</span>
													</div>
													<div class="form-block">
														<el-form-item label="Implementation Instructions">
															<div class="gray-input">
																{{ item2.implementation_instructions }}
															</div>
														</el-form-item>
													</div>
													<template v-if="correctiveExpanded == item2.id || allExpanded">
														<div class="form-block">
															<el-form-item label="Implementer">
																<div class="gray-input">
																	{{ item2.implementor_username }}
																</div>
															</el-form-item>
														</div>
														<div class="form-block">
															<el-form-item label="Planned Action Due Date">
																<div class="gray-input">
																	{{ initTime2(item2.end_time) }}
																</div>
															</el-form-item>
														</div>
														<div class="custom-panel">
															<div class="panel-header">
																<div class="table-title">Affected Files</div>
															</div>
															<el-table :data="item2.filelist" border stripe
																header-cell-class-name="table-header-cell"
																class="file-table" empty-text="No Affected Files">
																<el-table-column prop="" label="Description" sortable
																	min-width="200">
																	<template slot-scope="scope">
																		<div>
																			{{ scope.row.description || "/" }}
																		</div>
																	</template>
																</el-table-column>
																<el-table-column prop="fileName" label="File Name"
																	min-width="240">
																	<template slot-scope="scope">
																		<a :href="scope.row.url" target="_blank">{{
                                      scope.row.name
                                    }}</a>
																	</template>
																</el-table-column>
															</el-table>
														</div>
														<div class="form-block" style="margin-top: 20px">
															<el-form-item label="Verification Instructions">
																<div class="gray-input">
																	{{ item2.verification_instructions }}
																</div>
															</el-form-item>
														</div>
													</template>
													<div v-if="!allExpanded" class="section-toggle">
														<el-button type="text" @click="correctiveExpandedClick(item2)">
															{{
                                correctiveExpanded == item2.id || allExpanded
                                  ? "Collapse"
                                  : "Expand"
                              }}
															<i :class="
                                  correctiveExpanded == item2.id || allExpanded
                                    ? 'el-icon-arrow-up'
                                    : 'el-icon-arrow-down'
                                "></i>
														</el-button>
													</div>
												</section>
											</div>
										</div>
									</div>
									<!-- Solution Impact -->
									<div class="section-block">
										<div class="text-tip">Solution Impact</div>
										<el-form-item label="Impacts Documents?">
											<div class="gray-input">
												<span v-if="ruleForm1.impacts_documents == 1">Yes</span>
												<span v-if="ruleForm1.impacts_documents == 2">No</span>
											</div>
										</el-form-item>
										<el-form-item label="Impacts Production Output?">
											<div class="gray-input">
												<span v-if="ruleForm1.Impacts_product == 1">Yes</span>
												<span v-if="ruleForm1.Impacts_product == 2">No</span>
											</div>
										</el-form-item>
										<el-form-item label="Production Impact Description">
											<div class="gray-input">
												{{ ruleForm1.Impacts_description || "/" }}
											</div>
										</el-form-item>
										<el-form-item label="Change Authorization Requirements">
											<div class="gray-input">
												{{ ruleForm1.change_auth || "/" }}
											</div>
										</el-form-item>
									</div>
									<!-- CAPA Effectiveness Verification Plan -->
									<div class="section-block">
										<div class="text-tip">
											CAPA Effectiveness Verification Plan
										</div>
										<el-form-item
											label="Does this CAPA request require effectiveness verification?">
											<div class="gray-input">
												<span v-if="ruleForm2.capa_verification == 1">Yes</span>
												<span v-if="ruleForm2.capa_verification == 2">No</span>
											</div>
										</el-form-item>
										<el-form-item label="CAPA Verification Instructions">
											<div class="gray-input">
												{{ ruleForm2.capa_instructions }}
											</div>
										</el-form-item>
										<el-form-item label="Verification Plan Assignee">
											<div class="gray-input">
												{{ ruleForm2.capa_instructions_username }}
											</div>
										</el-form-item>
										<el-form-item label="Verification Plan Due Date">
											<div class="gray-input">
												{{ ruleForm2.capa_instructions_endtime }}
											</div>
										</el-form-item>
										<el-form-item label="Reason Verification Is Not Required">
											<div class="gray-input">
												{{ ruleForm2.nocapa_reason }}
											</div>
										</el-form-item>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Approvers</div>
										</div>
										<!-- 搜索框 -->
										<div style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin: 10px;
                      ">
											<div>Total {{ matchCount }} items</div>
											<el-input v-model="searchKeyword"
												placeholder="Enter keywords (space-separated)" clearable
												style="width: 300px" />
										</div>
										<el-table :data="filteredTableData" border stripe
											header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Data">
											<!-- Task Name -->
											<el-table-column prop="step_name" label="Task Name" min-width="120">
												<template #default="scope">
													<span v-html="highlight(scope.row.step_name)"></span>
												</template>
											</el-table-column>
											<!-- 负责人 -->
											<el-table-column label="Task Owner" min-width="150">
												<template #default="scope">
													<span v-html="
                              highlight(
                                scope.row.apply_username || 'Unassigned'
                              )
                            "></span>
												</template>
											</el-table-column>
											<!-- 企业 -->
											<!-- <el-table-column label="Owner Company" min-width="180">
												<template #default="scope">
													<span v-html="highlight(scope.row.company_name || 'N/A')"></span>
												</template>
											</el-table-column> -->
											<!-- 部门 -->
											<el-table-column label="Owner Department" min-width="180">
												<template #default="scope">
													<span v-html="
                              highlight(scope.row.departments_name || 'N/A')
                            "></span>
												</template>
											</el-table-column>
											<!-- Status -->
											<el-table-column label="Task Status/Result" min-width="150">
												<template #default="scope">
													<span v-html="
                              highlight(
                                getStatusText(
                                  scope.row.flow_leixing,
                                  scope.row.status
                                )
                              )
                            "></span>
												</template>
											</el-table-column>
											<!-- Comments -->
											<el-table-column prop="remark" label="Comments" min-width="210">
												<template #default="scope">
													<span v-html="highlight(scope.row.remark || '')"></span>
												</template>
											</el-table-column>
											<!-- 截止时间 -->
											<el-table-column prop="end_time" label="Task Due Date" min-width="150">
												<template #default="scope">
													<span v-html="highlight(scope.row.end_time)"></span>
												</template>
											</el-table-column>
											<!-- 完成时间 -->
											<el-table-column label="Completion Date" min-width="150">
												<template #default="scope">
													<span v-html="highlight(scope.row.app_time)"></span>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="input_el" style="margin-top: 20px">
										<div class="tit required">Approve this solution?</div>
										<el-form-item label="" prop="is_approval">
											<el-select filterable v-model="ruleForm.is_approval"
												placeholder="Please Select" style="width: 100%" clearable>
												<el-option label="Approve" :value="2"></el-option>
												<el-option label="Reject" :value="3"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="input_el">
										<div class="tit">Comments</div>
										<el-form-item label="" prop="remark">
											<el-input type="textarea" :rows="3" v-model="ruleForm.remark"
												placeholder="Please Enter" clearable></el-input>
										</el-form-item>
									</div>
									<div class="input_el">
										<div class="tit required">Password</div>
										<el-form-item label="" prop="signature">
											<el-input v-model="ruleForm.signature" placeholder="Please Enter" clearable
												show-password></el-input>
										</el-form-item>
									</div>
									<!-- Bottom Buttons -->
									<div class="footer-btn">
										<el-button type="primary" size="small" @click="handleSure('ruleForm')">
											Confirm
										</el-button>
										<el-button type="primary" size="small" @click="handleCancel">
											Cancel
										</el-button>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	import {
		resourcesApplyDetail
	} from "@/api/docManage/changeRequest/index";
	import {
		ApplyHandle
	} from "@/api/capaManage/capaRequest/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import md5 from "js-md5";
	import moment from "moment";
	export default {
		name: "CapaDetail",
		components: {
			headers,
			slider,
		},
		data() {
			return {
				showSolution: true,
				rootCauseExpanded: null,
				correctiveExpanded: null,
				allExpanded: false,
				info: {},
				backdocTableData: [],
				affectArticleTableData: [],
				correctionTableData: [],
				investigationLogTableData: [],
				rootCauseFiles: [],
				affectedFiles: [],
				rootCause: [], // 根本原因
				searchKeyword: "",
				matchCount: 0,
				historyTableData: [],
				ruleForm: {
					is_approval: "",
					remark: "",
					signature: "",
				},
				rules: {
					is_approval: [{
						required: true,
						message: "Please select",
						trigger: "change",
					}, ],
					signature: [{
						required: true,
						message: "Please enter",
						trigger: "blur",
					}, ],
				},
				ruleForm1: {
					impacts_documents: "",
					Impacts_product: "",
					Impacts_description: "",
					change_auth: "",
				},
				ruleForm2: {
					capa_verification: "",
					capa_instructions: "",
					capa_instructions_uid: "",
					capa_instructions_endtime: "",
					nocapa_reason: "",
					capa_instructions_username: "",
				},
				step: null,
			};
		},
		mounted() {
			let that = this;
			that.step = that.$route.query.step;
			//请求页面详情
			resourcesApplyDetail({
				id: that.$route.query.oid
			}).then((res) => {
				if (res.code == 200) {
					// console.log(res.data);
					that.info = {
						...that.info,
						id: res.data.id,
						request_id: res.data.request_id,
						status_name: res.data.status_name,
						priority: res.data.priority,
						investigator: res.data.investigator,
						description: res.data.description,
						username: res.data.username,
						// company_name: res.data.company_name,
						source_type: res.data.source_type,
						departments_name: res.data.departments_name,
						source_info: res.data.source_info,
						time1: res.data.time1,
						time2: res.data.time2,
						time3: res.data.time3,
						time4: res.data.time4,
						time5: res.data.time5,
						time6: res.data.time6,
						pass_time: res.data.pass_time,
						step_name: res.data.step_name,
					};
					// 回显CAPA背景文件
					that.backdocTableData = res.data.capabackground_list || [];
					// 回显更正文件
					that.correctionTableData = res.data.capacorrections_list || [];
					// 回显受影响的文章
					that.affectArticleTableData = res.data.capaarticle_list || [];
					// 活动日志
					that.investigationLogTableData = res.data.capaaffected_list || [];
					// 根本原因
					that.rootCause = res.data.caparootcause_list || [];
					// 解决方案的影响
					that.ruleForm1.impacts_documents = res.data.impacts_documents ?
						res.data.impacts_documents :
						"";
					that.ruleForm1.Impacts_product = res.data.Impacts_product ?
						res.data.Impacts_product :
						"";
					that.ruleForm1.Impacts_description = res.data.Impacts_description;
					that.ruleForm1.change_auth = res.data.change_auth;
					// CAPA有效性验证计划
					that.ruleForm2.capa_verification = res.data.capa_verification ?
						res.data.capa_verification :
						"";
					that.ruleForm2.capa_instructions = res.data.capa_instructions;
					that.ruleForm2.capa_instructions_endtime = res.data
						.capa_instructions_endtime ?
						that.initTime2(res.data.capa_instructions_endtime) :
						"";
					that.ruleForm2.capa_instructions_username =
						res.data.capa_instructions_username;
					that.ruleForm2.nocapa_reason = res.data.nocapa_reason;
					that.$nextTick(() => {
						that.ruleForm2.capa_instructions_uid = res.data.capa_instructions_uid ?
							res.data.capa_instructions_uid :
							"";
					});
					//审批记录
					that.historyTableData = res.data.apply_list;
				}
			});
		},
		computed: {
			// 分词
			keywords() {
				if (!this.searchKeyword) return [];
				return this.searchKeyword.toLowerCase().split(/\s+/).filter(Boolean);
			},
			// 过滤
			filteredTableData() {
				if (!this.keywords.length) {
					this.matchCount = this.historyTableData.length;
					return this.historyTableData;
				}
				const result = this.historyTableData.filter((row) => {
					return this.matchRow(row);
				});
				this.matchCount = result.length;

				this.$nextTick(() => {
					this.scrollToFirst();
				});
				return result;
			},
		},
		methods: {
			// 行匹配
			matchRow(row) {
				const fields = [
					row.step_name,
					row.apply_username || "Unassigned",
					// row.company_name || "N/A",
					row.departments_name || "N/A",
					this.getStatusText(row.flow_leixing, row.status),
					row.remark || "",
					row.end_time,
					row.app_time,
				];
				const text = fields.join(" ").toLowerCase();
				return this.keywords.every((k) => text.includes(k));
			},
			// 状态映射
			getStatusText(flow_leixing, status) {
				if (flow_leixing == 1) {
					const map = {
						1: "In Progress",
						2: "Approved",
						3: "Rejected",
						4: "Auto Rejected",
						9: "Withdrawn",
					};
					return map[status] || "";
				} else {
					const map = {
						1: "Unread",
						2: "Read",
					};
					return map[status] || "";
				}
			},
			// 高亮
			highlight(text) {
				if (!text) return "";
				let result = text.toString();
				this.keywords.forEach((k) => {
					const reg = new RegExp(
						`(${k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
						"gi"
					);
					result = result.replace(reg, '<span class="highlight">$1</span>');
				});
				return result;
			},
			// 滚动
			scrollToFirst() {
				const table = this.$refs.tableRef;
				if (!table) return;
				const el = table.$el.querySelector(".el-table__body-wrapper tbody tr");
				if (el) {
					el.scrollIntoView({
						behavior: "smooth",
						block: "center"
					});
				}
			},
			//初始化时间
			initTime(value) {
				if (value) {
					return moment(value * 1000).format("YYYY-MM-DD HH:mm:ss");
				} else {
					return "/";
				}
			},
			//初始化时间
			initTime2(value) {
				if (value) {
					return moment(value * 1000).format("YYYY-MM-DD");
				} else {
					return "/";
				}
			},
			//正式审查-6
			handleSure(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						ApplyHandle({
							id: that.$route.query.oid,
							status: that.ruleForm.is_approval,
							remark: that.ruleForm.remark,
							signature: md5(that.ruleForm.signature + "AiisoQms2026"),
						}).then((res) => {
							if (res.code == 200) {
								that.$toast.clear();
								that.$message.success("Operation successful");
								setTimeout(() => {
									that.$router.push({
										path: "/task-list"
									});
								}, 800);
							}
						});
					} else {
						return false;
					}
				});
			},
			handleCancel() {
				let that = this;
				that.$router.back();
			},
			submitForm(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (!valid) return;
				});
			},
			//展开 & 隐藏全部
			toggleAll() {
				let that = this;
				that.allExpanded = !that.allExpanded;
				if (!that.allExpanded) {
					that.rootCauseExpanded = null;
					that.correctiveExpanded = null;
				}
			},
			//展开 & 隐藏
			rootCauseExpandedClick(value) {
				let that = this;
				if (that.rootCauseExpanded == value.id) {
					that.rootCauseExpanded = null;
				} else {
					that.rootCauseExpanded = value.id;
				}
			},
			correctiveExpandedClick(value) {
				let that = this;
				if (that.correctiveExpanded == value.id) {
					that.correctiveExpanded = null;
				} else {
					that.correctiveExpanded = value.id;
				}
			},
		},
	};
</script>


<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>

<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label 样式 */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* 输入框统一风格 */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.custom-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 10px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.solution-plan {
		width: 100%;
		color: #303133;
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.plan-header {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.plan-title {
		font-size: 20px;
		font-weight: 700;
		color: #1f2d3d;
		margin-right: 8px;
	}

	.toggle-btn {
		padding: 0;
		font-size: 13px;
	}

	.plan-card {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #fff;
		overflow: hidden;
	}

	.plan-section {
		padding: 28px 20px 18px;
	}

	.section-title {
		margin: 0 0 26px;
		font-size: 24px;
		font-weight: 700;
		color: #303133;
	}

	.sub-title {
		font-size: 20px;
		font-weight: 700;
		color: #303133;
		margin-bottom: 20px;
	}

	.form-block {
		margin-bottom: 10px;
	}

	.field-label {
		display: block;
		margin-bottom: 5px;
		font-size: 14px;
		font-weight: 700;
		color: #303133;
	}

	.section-toggle {
		margin-top: 12px;
	}

	.section-toggle .el-button {
		padding: 0;
		font-size: 14px;
		font-weight: 600;
	}

	.divider {
		height: 1px;
		background: #ebeef5;
	}

	.custom-table {
		margin-bottom: 14px;
		width: 100%;
	}

	.el-icon-arrow-down,
	.el-icon-arrow-up {
		margin-left: 2px;
	}

	.footer-btn {
		display: flex;
		margin-top: 50px;
		justify-content: center;
		align-self: center;
	}

	.tit {
		padding-bottom: 5px;
		font-size: 14px;
		color: #333333;
	}

	.required::before {
		content: "*";
		color: red;
		margin-right: 2px;
	}
</style>